import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Empty } from 'antd';
import {
  Card,
  Flex,
  Table as BaseTable,
  TableProps,
  TextComponent,
} from '@monorepo/react-components';

type Props<T> = TableProps<T> & {
  label?: string | ReactNode;
};

export const Table = <T extends Record<string, any>>({
  label,
  ...antdProps
}: Props<T>) => {
  const { t } = useTranslation(['common']);

  const emptyText = (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={t('common:no_data', { defaultValue: 'No data' })}
    />
  );

  if (label) {
    return (
      <Card className="hub-table" hoverable={false}>
        <Flex vertical gap={16}>
          <TextComponent responsive={false} level={4}>
            {label}
          </TextComponent>
          <BaseTable<T> {...antdProps} locale={{ emptyText }} />
        </Flex>
      </Card>
    );
  }

  return (
    <div className="hub-table">
      <BaseTable<T> {...antdProps} locale={{ emptyText }} />
    </div>
  );
};
